import { createAction } from '@reduxjs/toolkit';

export const createLexiconRuleContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('CreateLexiconRuleContainer/NavigateTo'),
};
